# Managing job ads

## Before you begin

Job ad management generally requires a [partner token](/auth/partner-tokens);
browser tokens are supported for previews and queries.

## Operations

You can interact with [`PositionProfile`] objects by:

- [Previewing a job ad](/use-cases/job-posting/managing-job-ads/previewing-a-job-ad) using a `PositionProfile` input
- [Posting a job ad](/use-cases/job-posting/managing-job-ads/posting-a-job-ad) using a `PositionProfile` input
- [Querying a job ad](/use-cases/job-posting/managing-job-ads/querying-a-job-ad) to retrieve the `PositionProfile`’s data
- [Updating a job ad](/use-cases/job-posting/managing-job-ads/updating-a-job-ad) using a `PositionProfile` input and an existing job ad’s `profileId`
- [Closing a job ad](/use-cases/job-posting/managing-job-ads/closing-a-job-ad)

[`PositionProfile`]: /schema/named-type/PositionProfile
